export default __webpack_public_path__ + "static/media/chrome-blue.ca13b6be.svg";